export default __webpack_public_path__ + "static/media/H4009.66cb5bb1.mp3";